import { render } from "./homeEvaStat.vue?vue&type=template&id=8f35b020&scoped=true"
import script from "./homeEvaStat.vue?vue&type=script&lang=js"
export * from "./homeEvaStat.vue?vue&type=script&lang=js"

import "./homeEvaStat.vue?vue&type=style&index=0&id=8f35b020&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f35b020"]])

export default __exports__